module.exports = __webpack_public_path__ + "img/slider_comments_1.740f794e.jpg";